import React from 'react'
import Header from '../../Header/Header'
import Footer from '../../Footer/Footer'
import SubHeader from '../../Header/SubHeader'
import {connect} from 'react-redux'
import MerchantDashhead from '../MerchantDashhead';
import { IconButton,TextField,Button,Tooltip,Fab,Alert } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import "./Eligibility.scss"
import {getUserInfo,storeUserInfo} from '../../redux/user/userActions'
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import FormGroup from '@mui/material/FormGroup';
import * as FileSaver from 'file-saver';
import Checkbox from '@mui/material/Checkbox';
import { LocalizationProvider } from "@mui/x-date-pickers";
import {useForm} from 'react-hook-form'
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios'
import { setLoading } from '../../redux/loading/loadingActions'
function Eligibility(props) {
    const {handleSubmit,register,formState:{errors}}=useForm()
    const [error,setError] = React.useState("")
    const [open,setOpen]=React.useState(false)
    const [loading,setLoading]=React.useState(false)
    const [message,setMessage]=React.useState("")

    const onSubmit = (data)=>{
        console.log(data)
        // if(data.mobileNo==="7262805895"){
        //     setMessage(`This Mobile Number is Eligibile for Cleverpe Creditline`)
        //     setError("")
        // }else{
        //     setMessage("")
        //     setError("This Mobile Number is not Eligible for CleverPe EMI")
        // }
        if(data.mobileNo.length===10){
            props.setLoading(true)
            axios.post(`${process.env.REACT_APP_DEVELOPMENT}/api/b2b/cashe/preapproval`,{mobileNo:data.mobileNo, customerName:data.name},{headers:{token:props.user.user}})
            .then(res=>{
                props.setLoading(false)
                console.log(res)
                setError("")
                if(res.data.result==="Eligible"){
                    setMessage(`This Mobile Number is Eligibile for a transaction worth ₹${res.data.amount}`)
                }else{
                    setError("This Mobile Number is not Eligible for CleverPe EMI")
                }
            })
            .catch(err=>{
                props.setLoading(false)
                console.log(err)
                setError("This Mobile Number is not Eligible for CleverPe EMI")
                setMessage("")
            })
        }else{
            setError("Enter Valid Mobile Number")
        }
    }

  return (
    <div>
        <Header />
        <div className="desktop-visible">
        <SubHeader />
        </div>
    {!loading&&<div className="my-profile">

        <div className='desktop-container row m-auto'>
            <section className=" col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 menu-container p-0">
             <MerchantDashhead id={8} open={open} setOpen={setOpen}/>
                  

            </section>
            <section className="shadow col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 info-container">
                <div className='mobile-visible'>
                <IconButton onClick={()=>setOpen(true)}>
                    <MenuIcon />
                </IconButton>
                </div>
                <h1>Check Customer Pre Approval</h1>
                <form onSubmit={handleSubmit(onSubmit)}>
                <TextField {...register("mobileNo",{required:true})} className="my-3" id="outlined-basic" variant="outlined" label="Customer Mobile Number" fullWidth />
                <TextField {...register("name",{required:true})} className="my-3" id="outlined-basic" variant="outlined" label="Customer Name" fullWidth />
                {error.length>0&&<Alert className="alert" severity="error">{error}</Alert>}
                {message.length>0&&<Alert className="alert" severity="success">{message}</Alert>}
                <div style={{textAlign:"center"}}>
                <Button startIcon={<SearchIcon />} variant="contained" type="submit">Check Now</Button>
                </div>
                </form>


            </section>
        </div>
    </div>}
    <Footer />
    </div>
  )
}

const mapStateToProps = ({cleverpeUser,loading})=>{
    return {
        user:cleverpeUser,
        loading
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        getUserInfo:(token)=>dispatch(getUserInfo(token)),
        storeUserInfo:(user)=>dispatch(storeUserInfo(user)),
        setLoading:value=>dispatch(setLoading(value))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Eligibility)